import * as React from 'react';
import styled from 'styled-components';
import Cookies from 'universal-cookie';
import * as moment from 'moment';

import { ReactComponent as AlmaMediaLogo } from 'assets/logos/alma_media_logo.svg';

const BottomBanner = styled.div`
    display: flex;
    justify-content: space-between;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    max-height: 400px;
    background: #9c9389;
    box-sizing: border-box;
    z-index: 99999999;
    overflow: hidden;
    margin: 0;
    padding: 20px 16px;
    font-size: 14px;
    font-family: 'Noto Sans', Helvetica, Arial, sans-serif;
`;

const BannerHeading = styled.h4`
    color: #fff;
    font-weight: 700;
    font-size: 16px;
`;

const BannerParagraph = styled.p`
    color: #fff;
    font-weight: 200;
    font-size: 11px;
    line-height: 1.25;
`;

const BannerAnchor = styled.a`
    color: #fff;
    font-weight: 200;
    font-size: 11px;
    line-height: 1.25;
`;

const BannerTitleDiv = styled.div`
    float: right;
`;

const BannerLogo = styled.div`
    height: 60px;
    width: 60px;
`;

const CloseBannerButton = styled.button`
    float: right;
`;

export default function CookieBanner() {
    const cookieBannerCookieName = 'cookieBannerApproved';
    const cookies = new Cookies();
    const [showCookieBanner, setShowCookieBanner] = React.useState(false);

    const approveCookieBanner = () => {
        const expiryDate = moment().add(365, 'days');
        cookies.set(cookieBannerCookieName, true, {
            path: '/',
            expires: expiryDate.toDate()
        });
        setShowCookieBanner(false);
    };

    React.useEffect(() => {
        const bannerCookie = cookies.get(cookieBannerCookieName);
        if (Boolean(bannerCookie)) {
            setShowCookieBanner(false);
        } else {
            setShowCookieBanner(true);
        }
    }, []);

    return (
        <>
            {' '}
            {showCookieBanner && (
                <BottomBanner>
                    <BannerLogo>
                        <AlmaMediaLogo />
                    </BannerLogo>

                    <div>
                        <BannerHeading> TIETOSUOJA</BannerHeading>
                        <BannerParagraph>
                            Lisätiedot{' '}
                            <BannerAnchor
                                href="https://www.almamedia.fi/tietosuoja"
                                target="_blank"
                            >
                                almamedia.fi/tietosuoja
                            </BannerAnchor>
                        </BannerParagraph>
                    </div>

                    <div>
                        <BannerHeading>Käytämme evästeitä!</BannerHeading>
                        <BannerParagraph>
                            Käytämme Alma Median sivustoilla evästeitä.
                            Jatkamalla sivuston selaamista hyväksyt evästeiden
                            käytön.
                        </BannerParagraph>
                    </div>

                    <BannerTitleDiv>
                        <CloseBannerButton
                            onClick={approveCookieBanner}
                            title="Hyväksy ja sulje ilmoitus"
                        >
                            X Sulje
                        </CloseBannerButton>
                    </BannerTitleDiv>
                </BottomBanner>
            )}
        </>
    );
}
